<template>
  <div>
    <DxDropDownButton
      :items="getItems"
      :keyExpr="'ScreenLayoutApplicationFeatureCode'"
      :displayExpr="'ReportDisplayName'"
      :drop-down-options="{ width: 200 }"
      class="gc-dropdown-icon-button"
      icon="pdffile"
      styling-mode="text"
      :show-arrow-icon="false"
      :onItemClick="onItemClick"
      v-if="getItems.length > 1"
    />
    <DxButton
      class="invoice-print-btn"
      @click="onItemClick({ itemData: getItems[0] })"
      icon="pdffile"
      v-else
    />

    <GcPopupValidationSummary
      :showPopup.sync="validationSummaryVisible"
      :title="'Print Preview Errors'"
      :isXSmall="isXSmall"
      :items.sync="validationItems"
    ></GcPopupValidationSummary>
  </div>
</template>
<script>
import routeMixin from "../_mixins/route.mixin";
import ApiService from "../_services/api/api.service";
// eslint-disable-next-line no-unused-vars
import { TransactionReportService } from "../_services/api/reports/transaction-report.service";
// eslint-disable-next-line no-unused-vars
import { getGlobalField } from "../_store/helpers";

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export default {
  mixins: [routeMixin],
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    dataField: {
      type: String,
      default: "Code",
    },
    gridComponent: {
      type: Object,
      default: () => {},
    },
    gridColumns: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      printReports: undefined,
      validationSummaryVisible: false,
      validationItems: [],
    };
  },
  created() {
    // if (this.data.column.PrintPreview) {
    //   // if (this.data.column.makeDisabled)
    //   //   this.printReports = this.data.column.makeDisabled(this.data);
    //   // // this.data.column.PrintPreview.forEach((element) => {
    //   // //   element.disabled = this.data.column.makeDisabled(this.data , element);
    //   // // });
    //   // else
    //   this.printReports = this.data.column.PrintPreview;
    // } else this.printReports = [];
    // console.log('X1 ', this.getItems);
  },
  computed: {
    getItems() {
      if (this.data.column.PrintPreview)
        if (this.data.column.menuItems)
          if (this.data.column.menuItems.makeDisabled)
            return this.data.column.menuItems.makeDisabled(this.data);
          else return this.data.column.PrintPreview;
        else return this.data.column.PrintPreview;
      else return [];
    },
  },
  methods: {
    async onItemClick(rowData) {
      this.showLoading(true);

      if (rowData.itemData && rowData.itemData.ScreenLayoutApplicationFeatureCode) {
        var response;
        await TransactionReportService.getByFeatureCode(
          rowData.itemData.ScreenLayoutApplicationFeatureCode
        )
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.validationItems = [];
            this.validationItems.push("Report repx not found");
            this.validationSummaryVisible = true;
            return;
          });

        var report = undefined;

        if (response && response.data) {
          report = response.data;
          report.Parameters = JSON.parse(response.data.Parameters);
          this.ExportToPdf(
            this.getQueryString(
              rowData.itemData.Parameters,
              this.data,
              report.Location
            )
          );
        } else this.showLoading(false);
      } else this.showLoading(false);
    },
    getQueryString(parameters, value, reportLocation) {
      let link = `/api/GetReportPdf?reportLocation=${reportLocation}`;

      var params = JSON.parse(parameters);

      params.parameters.forEach((parameter) => {
        if (!parameter) return;
        var dataField = parameter.dataField;
        if (!value.data[dataField]) {
          let globalField = { ...getGlobalField(parameter.dataField) };
          if (globalField) {
            var index = this.gridColumns.findIndex(
              (x) => x.screenField == globalField.fieldName
            );
            if (index > -1) {
              dataField = this.gridColumns[index].dataField;
            }
          }
        }

        link += `&${parameter.parameterName}=${value.data[dataField]}`;
      });
      return link;
    },
    async ExportToPdf(url) {
      await ApiService.get(url)
        .then((res) => {
          const blob = b64toBlob(res.data, "application/pdf");
          const blobUrl = URL.createObjectURL(blob);
          this.showLoading(false);
          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: blobUrl,
          }).click();
        })
        .catch((error) => {
          this.$logger.debug("ExportToPdf Error ", error);
          this.showLoading(false);
        });
    },
  },
};
</script>

<style lang="scss"></style>
